import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { FC, Fragment, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import styles from './animatedTabs.module.scss';

interface IAnimatedTabsProps {
  list: string[];
  panels: ReactNode[];
  classNameList: string;
  classNamePanels: string;
  classNamePanel: string;
  classNameTab?: string;
  disabled?: boolean;
  controlled?: { selectedIndex: number; onChange: () => void };
}

const AnimatedTabs: FC<IAnimatedTabsProps> = ({
  list,
  panels,
  classNameList,
  classNamePanels,
  classNamePanel,
  classNameTab,
  disabled,
  controlled = null,
}) => {
  const tabs = controlled ?? {};

  return (
    <TabGroup {...tabs} as={Fragment}>
      <TabList className={twMerge(styles['tabs'], classNameList)}>
        {list.map((item, idx) => (
          <Tab
            key={idx}
            className={twMerge('button--styleless', styles['tab'], classNameTab)}
            disabled={idx > 0 && disabled}
          >
            {item}
          </Tab>
        ))}
      </TabList>
      <TabPanels className={classNamePanels}>
        {panels.map((panel, idx) => (
          <TabPanel key={idx} unmount={false} as="div" className={classNamePanel}>
            {panel}
          </TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  );
};

export default AnimatedTabs;
